const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Media library", "uipress-lite"),
  moduleName: "uip-media-library",
  description: __("Outputs a media library, with upload, delete and folder features", "uipress-lite"),
  group: "dynamic",
  icon: "photo_library",
};
